import SHA256 from 'crypto-js/sha256';

export const generateHashEmail = (email: string, salt: string): string => {
  return SHA256(`${email}${salt}`).toString();
};
